<style lang="scss">
.m2_info_sidebar {
  box-sizing: border-box;
  margin-top: 20px;
  padding: 35px 0;
  font-size: 14px;
  color: #4990e2;
  float: left;
  width: 205px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.05);
  background: white;
  .sidebar_title {
    font-size: 10px;
    color: #c2c5cf;
    padding-left: 40px;
    margin-bottom: 10px;
    padding-top: 30px;
  }
  .iconfont {
    font-size: 16px;
    color: #606266;
  }
  a {
    color: #606266;
  }
  .el-menu {
    width: 100%;
  }

  .el-submenu__title {
    padding: 0 40px !important;
  }

  .el-menu-item {
    padding: 0 !important;

    a {
      text-align: center;
      box-sizing: border-box;
      display: block;
      width: 100%;
      height: 100%;
      padding: 0 40px !important;
    }
  }
  .el-menu-item.is-active {
    background-color: #ecf5ff;
  }
  .el-menu-item.is-active * {
    color: #409eff;
  }
  .el-menu-item-group__title {
    padding: 0;
  }
  .el-menu-item-group {
    .el-menu-item {
      padding: 0 !important;
      a {
        padding: 0 65px !important;
      }
    }
  }
}
</style>
<template>
  <div class="m2_info_sidebar">
    <el-menu
      :default-active="activeIndex"
      :default-openeds="activeIndex.split('-')"
      class="el-menu-vertical-demo"
      @open="handleOpen"
    >
      <el-menu-item index="2">
        <router-link :to="{name:'default_moreAnnoucement'}">
          <span>通知公告</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="3">
        <router-link :to="{name:'default_morePolicySystem'}">
          <span>政策制度</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="1">
        <router-link :to="{name:'default_moreProblemSolving'}">
          <span>问题解答</span>
        </router-link>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {};
  },
  computed: {},
  props: {
    activeIndex: {
      type: String,
      default: "0"
    }
  },
  methods: {
    handleOpen(key, keyPath) {}
  }
};
</script>
